export const ChangeEvent = (name, value) => ({ target: { name, value } });
